import { useGetAccountRequests } from "@/entities/get-account-requests/fetch";
import { usePostAccountRequestApprove } from "@/entities/post-account-request-approve/fetch";
import { usePostAccountRequestReject } from "@/entities/post-account-request-reject/fetch";
import { useState } from "react";
import type { AccountRequest, AccountRequestListPageProps } from "../model";

export const useAccountRequestListPageProps =
  (): AccountRequestListPageProps => {
    const [selectedAccountRequest, setSelectedAccountRequest] =
      useState<AccountRequest>();

    const getAccountRequestsResponse = useGetAccountRequests({
      pagination: {
        // TODO: ページング機能を実装する際に修正
        displayLimit: 10000,
      },
    });
    const postAccountRequestApprove = usePostAccountRequestApprove();
    const postAccountRequestReject = usePostAccountRequestReject();

    const selectedAccountRequestApprovalStatus = (() => {
      if (postAccountRequestApprove.isSuccess) {
        return "approved";
      }
      if (postAccountRequestReject.isSuccess) {
        return "rejected";
      }
      if (
        postAccountRequestApprove.isPending ||
        postAccountRequestReject.isPending
      ) {
        return "loading";
      }
      return "none";
    })();

    const onAccountRequestSelect: AccountRequestListPageProps["onAccountRequestSelect"] =
      (accountRequest) => {
        if (selectedAccountRequest?.id !== accountRequest?.id) {
          postAccountRequestApprove.reset();
          postAccountRequestReject.reset();
          setSelectedAccountRequest(accountRequest);
        }
      };
    const onAccountRequestApprove: AccountRequestListPageProps["onAccountRequestApprove"] =
      (accountRequestId, password) => {
        postAccountRequestApprove.mutate({
          id: accountRequestId,
          data: {
            password,
          },
        });
      };
    const onAccountRequestReject: AccountRequestListPageProps["onAccountRequestReject"] =
      (accountRequestId) => {
        postAccountRequestReject.mutate({
          id: accountRequestId,
        });
      };

    const accountRequests: AccountRequestListPageProps["accountRequests"] =
      (() => {
        if (getAccountRequestsResponse.isError) {
          return {
            status: "error",
            error: {
              message: JSON.stringify(getAccountRequestsResponse.error),
            },
          };
        }
        if (
          getAccountRequestsResponse.isLoading ||
          getAccountRequestsResponse.isPending
        ) {
          return {
            status: "loading",
            data: undefined,
          };
        }
        return {
          status: "success",
          data: getAccountRequestsResponse.data.data,
        };
      })();

    return {
      accountRequests,
      selectedAccountRequest,
      selectedAccountRequestApprovalStatus,
      onAccountRequestSelect,
      onAccountRequestApprove,
      onAccountRequestReject,
    };
  };
